import React, { useEffect, useState } from "react";
import "./usergraph.css";
import axios from "axios";
import RewardPointsCard from "./login/RewardPointsCard";

const UserGraph = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUserRankings = async () => {
      try {
        const response = await axios.get(
          "https://s3napi.s3nsoftware.com/api/UserMaster/TopRankers?count=5"
        );
        //console.log(response.data)
        setUsers(response.data.slice(0, 5));
      } catch (error) {
        console.error("Error fetching user rankings:", error);
      }
    };

    fetchUserRankings();
  }, []);
  return (
    <div className="container-graph">
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
      
      </div>
      <h2>Top Users by Completed Quizzes</h2>
      {users.map((user, index) => (
        <div className="card" key={index}>
          {/* <div className="avatar" style={{ backgroundColor: getRandomColor() }}>
            {user.UserId.charAt(0).toUpperCase()}
          </div> */}
          <div className="card-content">
            <div
              className="profile-image"
              style={{ backgroundColor: "purple" }}
            >
              {user.UserId.charAt(0).toUpperCase()}
            </div>
            <span className="rank"> #{user.Rank}</span>
            <div className="info">
              <p>
                <strong></strong> {user.ScreenName}
              </p>
            </div>
          </div>
          <div className="satisfaction">
            Quizzes Done: {user.CompletedQuizzes}
          </div>
        </div>
      ))}
    </div>
  );
};

// Function to generate random colors for avatars
const getRandomColor = () => {
  const colors = ["#ff5722", "#3f51b5", "#009688", "#ff9800", "#3f51b5"];
  return colors[Math.floor(Math.random() * colors.length)];
};

export default UserGraph;
